/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Scrollspy from 'react-scrollspy';
import { ArrowBackToStart, ArrowGoToEnd, Icon, useScrollContext} from '@repo/ui';
import { gsap, ScrambleTextPlugin } from '@repo/utils/gsap';
import useEmblaCarousel from 'embla-carousel-react';
import {CURSOR_TYPES, ICONS} from "@repo/utils/constants";
import { getIdWithoutSpecialSymbols, getOldCssSizeValue} from "@repo/utils";
import {BREAKPOINTS} from "@repo/ui/themeSettings";
import NextLink from 'next/link';

const StyledElevatorNavContainer = styled.div`
	display: none;
	position: fixed;
	left: 50%;
	z-index: 20;
	transform: translate(-50%, 0);
	opacity: 0;
	transition: opacity 0.3s ease-in-out;
	&.visible {
		transition: opacity 0.3s ease-in-out;
		opacity: 1;
	}
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		display: flex;
		align-items: center;
		height: 47px;
		column-gap: ${getOldCssSizeValue(9, BREAKPOINTS.DESKTOP)};
		bottom: ${getOldCssSizeValue(30, BREAKPOINTS.DESKTOP)};
	}
`

const StyledElevatorNavWrapper = styled.div`
	backdrop-filter: blur(20px);
	background-color: rgba(231, 231, 231, 0.4);
	border-radius: 7px;
	flex-direction: row;
	align-items: center;
	transform-origin: left;
	display: flex;
	height: 47px;
	padding: 0 ${getOldCssSizeValue(18, BREAKPOINTS.DESKTOP)} 0 ${getOldCssSizeValue(23, BREAKPOINTS.DESKTOP)};
	bottom: ${getOldCssSizeValue(30, BREAKPOINTS.DESKTOP)};
`;

const StyledSectionHeaderItem = styled.li`
	color: rgba(5, 29, 39, 0.4);
	font-size: ${getOldCssSizeValue(14, BREAKPOINTS.DESKTOP)};
	font-weight: 600;
	line-height: 24px;
	text-transform: uppercase;
	margin-right: 32px;
	list-style-type: none;
	position: relative;
	width: fit-content;
	white-space: nowrap;
	word-wrap: break-word;
	overflow-wrap: normal;
	transition: color 0.3s ease-in-out;
	&:before {
		background: ${({ theme }) => theme?.colors?.dimGray || 'var(--secondary-color)'};
	}
	&:hover {
		transition: color 0.3s ease-in-out;
		color: #051D27;
		&:before {
			background: ${({ theme }) => theme?.colors?.dimGray || 'var(--secondary-color)'};
		}
	}

	
	&:after {
		content: '';
		position: absolute;
		right: -16px;
		top: calc(50% - 1px);
		width: 2px;
		height: 2px;
		border-radius: 50%;
		background-color: #051D27;
	}

	&.active-el {
		color: #051D27;
	}

	&.last {
		margin-right: 0;

		&:after {
			display: none;
		}
	}
`;

const StyledStickyNavContainer = styled.div`
	display: flex;
	width: 400px;
	ul {
		display: none;
		opacity: 1;
		width: 0;
		height: 0;
		position: absolute;
	}

	.embla {
		overflow: hidden;
		width: 100%;
		padding: 10px 0;
	}

	.embla__container {
		display: flex;
	}

	.embla__slide {
		-webkit-user-select: none; /* Safari */
		-ms-user-select: none; /* IE 10 and IE 11 */
		user-select: none; /* Standard syntax */
	}
`;

const StyledArrowTopWrapper = styled.div`
	width: 47px;
	height: 47px;
	background-color:rgba(238, 238, 238, 0.4);
	border-radius: 7px;
	backdrop-filter: blur(20px);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	.arrow-up{
		padding: 10px;
	}
	.elevator-array {
		width: 32px!important;
		height: 32px!important;
	}
	svg {
		transition: scale 0.2s ease-in-out;
	}
	&:hover {
		transition: transform 0.2s ease-in-out;
		svg {
			transition: scale 0.2s ease-in-out;
			scale: 1.1;
		}
	}
`;

const StyledArrowStartOrEndWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 10px 9px;

	&.start {
		margin-right: ${getOldCssSizeValue(7, BREAKPOINTS.DESKTOP)};
	}

	&.end {
		margin-left: ${getOldCssSizeValue(5, BREAKPOINTS.DESKTOP)};
	}
`;

const StyledBackToProjects = styled.div`
	p {
		color: #051D27;
		font-weight: 400;
		font-size: ${getOldCssSizeValue(14, BREAKPOINTS.DESKTOP)};
		line-height: 24px;
	}
	border-radius: 7px;
	background-color:rgba(238, 238, 238, 0.4);
	backdrop-filter: blur(20px);
	display: flex;
	align-items: center;
	white-space: nowrap;
	height: 47px;
	padding: 0 14px;
`

const StyledProjectsLink = styled(NextLink)`
	color: #051D27;
	font-weight: 400;
	font-size: ${getOldCssSizeValue(14, BREAKPOINTS.DESKTOP)};
	line-height: 24px;
	cursor: default;
	text-decoration: none;
	position: relative;
	&:before {
		background: ${({ theme }) => theme?.colors?.dimGray || 'var(--secondary-color)'};
	}
	&:hover {
		&:before {
			background: ${({ theme }) => theme?.colors?.dimGray || 'var(--secondary-color)'};
		}
	}
`

const StyledProjectStory = styled.div`
	color: #051D27;
	font-weight: 900;
	margin-right: ${getOldCssSizeValue(6, BREAKPOINTS.DESKTOP)};
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		font-size: ${getOldCssSizeValue(14, BREAKPOINTS.DESKTOP)};
		line-height: 24px;
	}
`

gsap.registerPlugin(ScrambleTextPlugin);
const SingleProjectElevatorNav = ({ data, locale, projectElevatorText }) => {
	const items = data.map((item) => getIdWithoutSpecialSymbols(item.anchor));
	const [activeItem, setActiveItem] = useState(0);
	const [isElevatorVisible, setIsElevatorVisible] = useState(false);
	const projectStory = locale === 'en' ? 'project story:' : 'historia projektu:';
	const backToProjects = locale === 'en' ? 'back to projects' : 'powrót do projektów';
	const [emblaRef, emblaApi] = useEmblaCarousel({
		align: 'center',
		dragFree: false,
		active: true,
	});
	const { instance: scrollInstance } = useScrollContext();
	const emblaContainerRef = useRef();

	const scrollToSectionName = (slug) => {
		const element = document.getElementById(slug);
		scrollInstance.scrollTo(element, { duration: 1, offset: -150 });
		// if (scrollInstance.scroll < element.offsetTop) {
		// 	// window.scroll({
		// 	// 	behavior: 'smooth',
		// 	// 	top: element.offsetTop,
		// 	// });
		// 	scrollInstance.scrollTo(element, { duration: 1 });
		// } else {
		// 	// window.scroll({
		// 	// 	behavior: 'smooth',
		// 	// 	top: element.offsetTop - 150,
		// 	// });
		// 	scrollInstance.scrollTo(element, { duration: 1, offset: -150 });
		// }
	};

	const scrollToTop = () => scrollInstance.scrollTo(0, { duration: 1 });
	const handleScrollActions = () => {
		//hiding bar when user stops scrolling
		// onScrollStop(() => {
		// 	setIsElevatorVisible(false);
		// });
		const scrollDistance = window?.scrollY || 0;
		if (scrollDistance > 200) {
			setIsElevatorVisible(true);
		} else {
			setIsElevatorVisible(false);
		}
	};
	useEffect(() => {
		if (emblaApi) {
			if (activeItem !== -1) {
				emblaApi.scrollTo(activeItem);
			}
		}
	}, [emblaApi, activeItem]);

	useEffect(() => {
		handleScrollActions();
		window.addEventListener('scroll', handleScrollActions);
		return () => window.removeEventListener('scroll', handleScrollActions);
	}, []);

	// const onScrollStop = (callback) => {
	// 	let isScrolling;
	// 	window.addEventListener(
	// 		'scroll',
	// 		(e) => {
	// 			clearTimeout(isScrolling);
	// 			isScrolling = setTimeout(() => {
	// 				callback();
	// 			}, 500);
	// 		},
	// 		false,
	// 	);
	// };

	const handleUpdate = () => {
		const elements = document.querySelector('div#section-elevator div.nav-container ul');
		const arrayOfScrollSpyElements = Array.from(elements.children);
		const element = document.querySelector('div#section-elevator div.nav-container li.active');
		const indexOfActiveSpyElement = arrayOfScrollSpyElements.indexOf(element);
		if (indexOfActiveSpyElement !== -1) {
			setActiveItem(indexOfActiveSpyElement);
		}
	};

	const handleActionOnClick = (key, anchor) => {
		scrollToSectionName(anchor);
	};

	const handleArrowRightClick = () => {
		const isAfterPin = data[activeItem + 1]?.afterPin || false;
		const anchor = data[activeItem + 1]?.anchor || '';
		const finalAnchor = getIdWithoutSpecialSymbols(anchor);
		if((activeItem < items.length - 1) && finalAnchor) {
			scrollToSectionName(finalAnchor);
			setActiveItem(activeItem + 1);
		}
		// if (isAfterPin && anchor) {
		// 	scrollToSectionName(anchor);
		// 	setActiveItem(activeItem + 1);
		// } else {
		// 	if (activeItem < items.length - 1) {
		// 		scrollToSectionName(items[activeItem + 1]);
		// 		setActiveItem(activeItem + 1);
		// 	}
		// }
	};

	const handleArrowLeftClick = () => {
		if (activeItem > 0) {
			const anchor = data[activeItem - 1]?.anchor || '';
			const finalAnchor = getIdWithoutSpecialSymbols(anchor);
			// scrollToSectionName(items[activeItem - 1]);
			scrollToSectionName(finalAnchor);
			setActiveItem(activeItem - 1);
		}
	};

	return (
		<StyledElevatorNavContainer
			onMouseOver={() => {setIsElevatorVisible(true);}}
			className={isElevatorVisible ? 'visible' : ''}
			id="section-elevator">
			<StyledArrowTopWrapper onClick={() => scrollToTop()}>
				<Icon className='elevator-array' data-cursor={CURSOR_TYPES.CIRCLE} name={ICONS.ARROWUP} color="#051D27"/>
			</StyledArrowTopWrapper>
			<StyledBackToProjects>
				<StyledProjectsLink className='underline-animation' data-cursor={CURSOR_TYPES.LINK} href={`/projects`}>{backToProjects}</StyledProjectsLink>
			</StyledBackToProjects>
			<StyledElevatorNavWrapper>
				<StyledProjectStory>{projectElevatorText}</StyledProjectStory>
				<StyledArrowStartOrEndWrapper data-cursor={CURSOR_TYPES.CIRCLE} onClick={() => handleArrowLeftClick()} className="start">
					<ArrowBackToStart/>
				</StyledArrowStartOrEndWrapper>
				<StyledStickyNavContainer className="nav-container">
					<Scrollspy items={items} currentClassName="active" offset={-150} onUpdate={() => handleUpdate()}>
						{data.map((item, key) => {
							const text = item?.text || '';
							const anchor = item?.anchor || '';
							const finalAnchor = getIdWithoutSpecialSymbols(anchor);
							return (
								<StyledSectionHeaderItem key={anchor} onClick={() => handleActionOnClick(key, finalAnchor)}>
									{text}
								</StyledSectionHeaderItem>
							);
						})}
					</Scrollspy>
					<div className="embla" ref={emblaRef}>
						<div ref={emblaContainerRef} className="embla__container">
							{data.map((item, key) => {
								const text = item?.text || '';
								const anchor = item?.anchor || '';
								const finalAnchor = getIdWithoutSpecialSymbols(anchor);
								const afterPin = item?.afterPin || '';
								return (
									<StyledSectionHeaderItem
										key={anchor}
										data-cursor={CURSOR_TYPES.LINK}
										onClick={() => handleActionOnClick(key, finalAnchor)}
										className={
											activeItem === key
												? 'active-el embla__slide underline-animation'
												: key === data.length - 1
													? 'last embla__slide underline-animation'
													: 'embla__slide underline-animation'
										}
									>{text}
									</StyledSectionHeaderItem>
								);
							})}
						</div>
					</div>
				</StyledStickyNavContainer>
				<StyledArrowStartOrEndWrapper data-cursor={CURSOR_TYPES.CIRCLE} onClick={() => handleArrowRightClick()} className="end">
					<ArrowGoToEnd/>
				</StyledArrowStartOrEndWrapper>
			</StyledElevatorNavWrapper>
		</StyledElevatorNavContainer>
	);
};

export default SingleProjectElevatorNav;
